/**
 * "How we measure ROI" — Guides section (C-11 / ADR-0294). The PUBLIC, auditable
 * resolution methodology: the confirmed-vs-assumed rubric, the tenant-editable
 * human-cost model, and the cost-per-resolution definition. Publishing the rubric
 * is the point — it is the transparency that answers the opacity of per-resolution
 * incumbents. Read-only positioning; links back to the Impact dashboard docs.
 */
import type { DocPageContent } from '../types';

export const GUIDES_ROI_METHODOLOGY_PAGE: DocPageContent = {
  slug: 'guides/roi-methodology',
  titleKey: 'docs.guides.roi.title',
  descriptionKey: 'docs.guides.roi.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.guides.roi.lead' },

    { kind: 'heading', level: 2, id: 'resolutions', textKey: 'docs.guides.roi.rubric.heading' },
    { kind: 'paragraph', textKey: 'docs.guides.roi.rubric.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.guides.roi.rubric.confirmed.term',
          descKey: 'docs.guides.roi.rubric.confirmed.desc',
        },
        {
          termKey: 'docs.guides.roi.rubric.assumed.term',
          descKey: 'docs.guides.roi.rubric.assumed.desc',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.guides.roi.excluded.title',
      textKey: 'docs.guides.roi.excluded.body',
    },

    { kind: 'heading', level: 2, id: 'value', textKey: 'docs.guides.roi.value.heading' },
    { kind: 'paragraph', textKey: 'docs.guides.roi.value.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.guides.roi.value.item.humanCost',
        'docs.guides.roi.value.item.syncanixCost',
        'docs.guides.roi.value.item.net',
      ],
    },

    { kind: 'heading', level: 2, id: 'honesty', textKey: 'docs.guides.roi.honesty.heading' },
    { kind: 'paragraph', textKey: 'docs.guides.roi.honesty.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.guides.roi.honesty.privacy.title',
      textKey: 'docs.guides.roi.honesty.privacy.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.guides.roi.related.impact.title',
          textKey: 'docs.guides.roi.related.impact.text',
          // The outcome mix this card promises lives on the ANALYTICS page, not
          // on Monitoring. The card was titled "Agent Impact dashboard" and
          // pointed at Monitoring, so it named a dashboard page that no longer
          // exists AND opened the wrong docs page for the ROI reader.
          to: { docSlug: 'dashboard/analytics' },
        },
        {
          titleKey: 'docs.guides.roi.related.pricing.title',
          textKey: 'docs.guides.roi.related.pricing.text',
          to: { docSlug: 'billing/limits' },
        },
      ],
    },
  ],
};
